import type { SketchGroup } from '../../../mesh/sketch';
import { SketchProfileBindingPayloadBuilder } from '../../runtime/SketchProfileBindingPayloadBuilder';

/**
 * 拉伸轮廓输入。
 */
export interface BossExtrudeContourBindingInput {
    /** 轮廓源对象 ID。 */
    contourSourceObjectId?: string;
    /** 轮廓键。 */
    contourKey?: string;
    /** 区域几何。 */
    regionGeometry: ProfileRegionGeometry;
}

/**
 * 拉伸绑定工厂。
 */
export class BossExtrudeFeatureBindingFactory {
    /**
     * 构建序列化 binding 集合。
     * @param input 构建输入。
     * @returns 序列化 binding 集合。
     */
    public static buildSerializedBindings(input: {
        sketchId?: string | null;
        sketchGroup?: SketchGroup | null;
        contours: BossExtrudeContourBindingInput[];
    }): SerializedFeatureReferenceBinding[] {
        if (!input.sketchId || input.contours.length === 0) {
            return [];
        }

        return [
            SketchProfileBindingPayloadBuilder.build({
                sketchId: input.sketchId,
                sketchGroup: input.sketchGroup ?? null,
                contours: input.contours.map((contour) => ({
                    contourSourceObjectId: contour.contourSourceObjectId,
                    contourKey: contour.contourKey,
                    regionGeometry: contour.regionGeometry,
                })),
            }),
        ];
    }
}
